import { AtlBrowserStorageSession } from '@atlassian/browser-storage-controls';

const TEST_KEY = '__session_storage_test__';

function SessionStorageFacade() {
  function isSupported() {
    try {
      AtlBrowserStorageSession.setItem(TEST_KEY, TEST_KEY);
      AtlBrowserStorageSession.removeItem(TEST_KEY);
      return true;
    } catch (e) {
      return false;
    }
  }

  function setItem(key: string, value: string) {
    if (!isSupported()) {
      return;
    }

    AtlBrowserStorageSession.setItem(key, value);
  }

  function getItem<T extends string>(key: string): T | null {
    if (!isSupported()) {
      return null;
    }
    return AtlBrowserStorageSession.getItem(key) as T;
  }

  function removeItem(key: string) {
    if (!isSupported()) {
      return null;
    }
    return AtlBrowserStorageSession.removeItem(key);
  }

  return {
    isSupported,
    getItem,
    setItem,
    removeItem,
  };
}

export default SessionStorageFacade();
